import { styled } from "styled-components";

export const ReloadButton = styled.div`
  svg {
    width: 25px;
    height: 30px;
  }
`;
